export default __webpack_public_path__ + "static/media/img-trabajo-2.1b9134ea.jpg";